import { useEffect, useState } from 'react';
import { Select, FormControl, InputLabel, OutlinedInput, MenuItem, Box, Chip, Checkbox, ListItemText } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import React from 'react';

interface IProps {
  id: string;
  items: Array<any>;
  itemKey: string;
  itemText: string;
  labelText: string;
  multiSelect: boolean;
  placeHolderText?: string;
  controlWidth?: number;
  labelPaddingTop?: string;
  defaultValue?: any;
  onChange?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isRequired?: boolean;
  hasError?: boolean;
  disabled?: boolean;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

const FuelSelect = ({
  id,
  items,
  itemKey,
  itemText,
  labelText,
  multiSelect,
  placeHolderText = 'Select option',
  controlWidth,
  labelPaddingTop,
  defaultValue,
  onChange,
  isRequired = false,
  hasError = false,
  disabled = false,
}: IProps) => {
  // console.log('FuelSelect', defaultValue);

  // Set defaults
  if (placeHolderText == null) placeHolderText = 'Select option';
  if (!itemKey) itemKey = 'id';
  if (!items) items = [];

  if (!defaultValue) {
    if (multiSelect) {
      defaultValue = [];
    } else {
      defaultValue = '';
    }
  }

  // console.log('FuelSelect', { defaultValue, items, multiSelect });

  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [selectedValues, setSelectedValues] = useState(defaultValue);

  useEffect(() => {
    setSelectedValue(defaultValue);
    setSelectedValues(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // console.log('value', value);
    if (multiSelect) {
      setSelectedValues(value);
      if (onChange) onChange(value);
    } else {
      setSelectedValue(value);
      if (onChange) onChange(value);
    }
  };

  const handleDelete = (event, value) => {
    // console.log('event', event);
    // console.log('value', value);
    const items = selectedValues.filter((item) => item[itemKey] !== value[itemKey]);
    setSelectedValues(items);
    if (onChange) onChange(items);
  };

  const renderValue = (selected) => {
    if (!multiSelect) return selected[itemText];
    return (
      <Box
        // onMouseDown={(event) => event.stopPropagation()}
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxHeight: '50px', overflow: 'auto' }}
      >
        {selected.map((value, index) => (
          <Chip
            className="tag-chip cat"
            key={`${index}-${value[itemText]}`}
            label={value[itemText]}
            color="primary"
            clickable
            size="small"
            deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
            onDelete={(e) => {
              handleDelete(e, value);
            }}
            sx={{ borderRadius: 0 }}
          />
        ))}
      </Box>
    );
  };

  // useEffect(() => {
  // // console.log('isRequired', isRequired);
  // }, [selectedValues]);

  return (
    <FormControl className="fuel-select" sx={{ m: 0 }} error={hasError}>
      <InputLabel>{labelText}</InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id={id}
        input={<OutlinedInput label={labelText} />}
        MenuProps={MenuProps}
        onChange={handleChange}
        value={multiSelect ? selectedValues : selectedValue}
        multiple={multiSelect}
        placeholder={placeHolderText}
        renderValue={(selected) => renderValue(selected)}
        size="small"
        required={isRequired}
        error={hasError}
        disabled={disabled}
        // SelectDisplayProps={{ style: { paddingTop: 7, paddingBottom: 7 } }}
      >
        {items?.map((item) => {
          if (multiSelect) {
            return (
              <MenuItem key={item[itemKey]} value={item}>
                <Checkbox
                  size="small"
                  color="success"
                  style={{
                    transform: 'scale(.6)',
                  }}
                  checked={selectedValues && selectedValues.findIndex((v) => v[itemKey] === item[itemKey]) >= 0}
                />

                <ListItemText primary={item[itemText]} />
              </MenuItem>
            );
          }
          return (
            <MenuItem key={item[itemKey]} value={item}>
              {item[itemText]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default FuelSelect;
